import { Injectable } from '@angular/core';
import {ApiCmsService} from "./api.cms.service";
import {map} from "rxjs/internal/operators/map";
const routes = {
  getNotifications:  `/notification/show-notification`,
  saveLog: `/notification/save-none-display`
};
@Injectable({
  providedIn: 'root'
})
export class NotificationCmsService {

  constructor( private apiService: ApiCmsService) { }


  public saveNoneDisplay(body: any) {
    return this.apiService.post(routes.saveLog, body)
      .pipe(map(res => {
        return res;
      }));
  }

  public getNotification() {
    return this.apiService.getAndShowDialog(routes.getNotifications, null, (data: any)=> {
      if (data && data.length)
      this.saveNoneDisplay({
        notificationCmsIds: data.map(e => e.notificationCmsId)
      }).subscribe(res => {

      })
    }, () => {
    });
  }
}
